import styled from 'styled-components';
import { datePickerContainerWidth } from '@/app/components/search/components/DatePickers/DatePicker/styled.ts';

export const WeekStyled = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  clear: both;
  position: fixed;
  top: 54px;
  left: 0;
  z-index: 24;
  padding: 0 16px;
  background-color: white;
  ${datePickerContainerWidth};
  margin: 0 auto;

  @media only screen and (min-width: 768px) {
    height: 15px;
    margin-bottom: 15px;
    position: relative;
    border-bottom: none;
    top: 0;
    z-index: 1;
    padding: 0;
  }

  @media (min-width: 768px) {
    .custom-checkin-checkout-modal & {
      background-color: white;
    }
  }
`;

export const WeekItemsStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 28px;
  line-height: 28px;
  margin: auto;
`;

export const WeekItemStyled = styled.div`
  float: left;
  text-align: center;
  border: 1px solid transparent;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  text-transform: capitalize;
  user-select: none;
  width: calc(100% / 7);
  border: none;
  font-style: normal;
  font-weight: normal;
  font-size: ${({ theme }) => theme.kallisto.font.size['150']};
  height: 18px;
  line-height: 18px;
  text-transform: uppercase;
  @media only screen and (min-width: 768px) {
    ${({ theme }) => theme.kallisto.font.size['150']};
    line-height: 15px;
    text-transform: unset;
  }
`;
